import * as React from 'react';
import { RowContainerComponentProps } from 'ui/common/types';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { TileView } from 'ui';
import { AttachLinkSelector } from '../attach-link-selector/attach-link-selector';

export interface AttachLinkTileViewProps extends RowContainerComponentProps {
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  textAddItem: string;
  textLinkTitle?: string;
  textLinkUrl?: string;
  textDone?: string;
  textInvalidUrlMessage?: string;    
  placeholderLinkUrl?: string;  
}

export const AttachLinkTileView: React.FC<AttachLinkTileViewProps> = (props: AttachLinkTileViewProps) => {
  
    const required = props.label && props.label.required;
    
    const addButton = <AttachLinkSelector {
                        ...{
                          required, children: undefined, ...props
                        }} 
                      />;
  
    return (     
      <div id={props.componentId} className={`col-12 ${props.className}`}>
        <div className="row">
          <TileView {...{addButton,  rowClassName:'col-md-6', ...props}}/>
        </div>
      </div>
    );
  };
